import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import { useSelector } from '~/store/hooks'

import trads from '~/intl/trads.json'

import ButtonArrow from '~/components/core/buttonArrow'
import Slider from '~/components/core/slider'
import EventCard from '~/components/features/cards/eventCard'
import NewsCard from '~/components/features/cards/NewsCard'
import SocialCard from '~/components/features/cards/socialCard'
import GetNewsroomUrls from '~/utils/getNewsroomUrls'

const NewsroomFeatured = ({ events, news, type = 'regular' }) => {
  const lang = useSelector((state) => state.lang)
  const newsroomUrls = GetNewsroomUrls()

  const [sliderItems, setSliderItems] = useState([])

  const flickityOptions = {
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    groupCells: true,
  }

  useEffect(() => {
    Axios.get('https://www.juicer.io/api/feeds/terega')
      .then(function (response) {
        // handle success
        let RSPosts = response.data.posts.items.slice(0, 3)
        let sliderItems = []
        let newsIndex = 0

        for (var i = 0; i < 3; i++) {
          let tempNewsRs = []
          const eventItem = events[i]

          // push first actu
          tempNewsRs.push(news[newsIndex])

          // if no event, push second actu
          if (!eventItem) {
            tempNewsRs.push(news[newsIndex + 1])
            newsIndex = newsIndex + 2
          } else {
            newsIndex++
          }

          // RS post
          tempNewsRs.push(RSPosts[i])

          tempNewsRs = tempNewsRs.sort(
            (a, b) =>
              new Date(
                b.publicationDate ? b.publicationDate : b.external_created_at,
              ) -
              new Date(
                a.publicationDate ? a.publicationDate : a.external_created_at,
              ),
          )

          sliderItems = sliderItems.concat(tempNewsRs)

          if (eventItem) {
            sliderItems.push(eventItem)
          }
        }

        setSliderItems(sliderItems)
      })
      .catch(function (error) {
        // handle error
        console.log(error)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const title =
    type === 'regular'
      ? trads[lang].lab.titleContentTypes.news
      : trads[lang].home.focusOn

  // console.log('sliderItems')

  return (
    <div
      className={`section ${type !== 'hp' && 'section--newsroom'} overflow-hidden`}
    >
      <div className="fluid-grid">
        <div className="row">
          <div className="col-12 lg-col-10 mx-auto">
            <h2 className="title-cut title-cut--blue text-white mt-4 md:mt-0 mb-12 md:mb-19">
              {title}
            </h2>

            <div className="slider-featured">
              <img
                className="slider-featured__deco-left hidden lg:block"
                src="/img/hp-decos/hp-featured-left.png"
                alt=""
              />
              <img
                className="slider-featured__deco-right hidden md:block"
                src="/img/hp-decos/hp-featured-right.svg"
                alt=""
              />
              <img
                className="slider-featured__deco-mobile md:hidden"
                src="/img/hp-decos/hp-featured-mobile.png"
                alt=""
              />
              {sliderItems.length > 0 && (
                <div className="slider-featured__inner">
                  <Slider
                    flickityOptions={flickityOptions}
                    navClasses="mt-2 md:mt-6 text-center md:text-left"
                    groupCells='{"320": 1, "768" : 2, "1280": 3}'
                    iconColor="purple"
                  >
                    {sliderItems
                      ?.filter((e) => e !== undefined)
                      ?.map((item, index) => {
                        const isXl = index % 3 === 0 // Calculate once per loop iteration
                        return (
                          <div
                            key={item?.id || index} // Use a unique 'id' if available
                            className={`slider-featured__slide ${isXl ? 'slider-featured__slide--xl' : ''}`}
                          >
                            <>
                              {item?.internal?.type === 'ContentfulEvent' && (
                                <EventCard event={item} isXl={isXl} />
                              )}
                              {item?.internal &&
                                item?.internal?.type !== 'ContentfulEvent' && (
                                  <NewsCard news={item} isXl={isXl} />
                                )}
                              {!!item && !item?.internal && (
                                <SocialCard social={item} />
                              )}
                            </>{' '}
                          </div>
                        )
                      })}
                  </Slider>
                </div>
              )}
              <ButtonArrow
                text={trads[lang].home.goNewsroom}
                link={`/${newsroomUrls['Hub'][lang]}`}
                color="purple"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewsroomFeatured
